

import React from 'react'
import "./Button.css";

function Logout() {
  return (
    <div>
        <button className='logout-btn'>Logout</button>
    </div>
  )
}

export default Logout